module.exports = __webpack_public_path__ + "static/media/whichThinnerNotAdjusted.3e637d8a.mp3";